export default __webpack_public_path__ + "static/media/year.f003b0ec.png";